import React from "react";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import Icon, { ICON_TYPE } from "components/Icon";
import { colors } from "style";
import { StyledTag } from "components/Tags";

/**
 * TagComplete
 */
const TagComplete = (props) => (
  <StyledTag css={styles.container}>
    <Icon type={ICON_TYPE.checkmark} color={`#fff`} {...props} />
    <FormattedMessage id="Global.Completed" />
  </StyledTag>
);

const styles = {
  container: css`
    background: ${colors.green};
    gap: 0.5rem;
  `,
};

export default TagComplete;
